<template>
    <div id="page_data" ref="page_data" class="hidden">
   <section class="page-title jumbotron" id="infants">
    <div class="auto-container">
       <div class="inner-container clearfix">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Home</a></li>
            <li><a href="/staff/">Staff Members</a></li>
             <li>{{pageData.name}}</li>
          </ul>
          <h1>{{pageData.name}}</h1>
       </div>
    </div>
    <div class="blog-object1 d-none d-xl-block skrollable skrollable-between" data-0="opacity:1;" data-100="transform:translatey(0%);" data-1025="transform:translatey(-80%);" style="opacity: 1; transform: translateY(0%);">
       <!-- Image -->
      <span class="d-block icon icon icon-pencil"></span>
    </div>
    <div class="blog-object2 d-none d-xl-block skrollable skrollable-between" data-0="opacity:1;" data-100="transform:translatey(0%);" data-1025="transform:translatey(-80%);" style="opacity: 1; transform: translateY(0%);">
     <!-- Image -->
      <span class="d-block icon icon-idea"></span>
   </div>
 </section>
 <!--End Page Title-->
 <!-- svg divider -->
 <svg id="main-divider" class="d-none d-xl-block" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 1920 120">
   <path fill-rule="evenodd" fill="#fff" d="M0,55.9621684 C300.495844,106.578393 620.495844,106.578393 960,55.9621684 C1299.50416,5.34594386 1619.50416,5.34594386 1920,55.9621684 L1920,120 L0,120 L0,55.9621684 Z"></path>
 </svg>
 <!-- Section -->
 <section class="pages">
    <div class="container">
       <div class="row">
          <!-- main wrapper -->
          <div class="main col-lg-9">
             <h2>{{pageData.name}}</h2>
             <img :src="pageData.image" class="mt-1 col-md-5 float-right p-2 img-fluid rounded"/>
              <p>{{pageData.details}}</p>
          </div>
          <!-- /col-lg-9 -->
          <!-- sidebar programs include -->
                         <!-- Sidebar Column -->
   <div class="sidebar col-lg-3 h-50 pink-bg ">

<!-- Sidebar heading -->
 <h4>Staff</h4>
   <ul class="sidebar-ul">
                <li> <a href="/curriculum/infants.phtml">Alina Rohdes</a></li>
                <li> <a href="/curriculum/toddlers.phtml">Camron Carlos</a></li>
                <li> <a href="/curriculum/preschool.phtml">Hana Mcgregor</a></li>
                <li> <a href="/curriculum/school.phtml">Melania Adward</a></li>
                <li> <a href="/curriculum/summer.phtml">Richerd clark</a></li>
   </ul>
   </div>
       </div>
       <!-- /row -->
    </div>
    <!-- /container-->
 </section>
    </div>
</template>
<script>
import {
  program_temp,
} from "./ProgramTemplate";

export default {
    data() {
        return{
          main:program_temp,
        }
    },
    watch:{
      isSidebarActive(val){
          if(val){
               let doc = new DOMParser().parseFromString(this.main, "text/html");
               var d1 = doc.getElementsByTagName("NAV")[0];
               d1.insertAdjacentHTML('afterend', this.$refs.page_data.innerHTML);
               this.$emit('setStaffTemplate',doc.documentElement.outerHTML)
               
          }
      }
    },
    props: {
    isSidebarActive: {
      type: Boolean,
    },
    pageData: {
      type: Object,
      default: () => {},
    }
  },
}
</script>
